import { Dialog, DialogContent } from '@/components/ui/dialog'

export const DemoModal = ({
  isOpen,
  setIsOpen,
  embedSrc,
}: {
  isOpen: boolean
  setIsOpen: (v: boolean) => void
  embedSrc?: string
}) => {
  const src =
    embedSrc ||
    'https://www.youtube.com/embed/75Z576-QFLU?autoplay=1' /* fallback to old teaser */

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) setIsOpen(false)
      }}
    >
      <DialogContent size="lg" className="text-white max-h-[85vh] w-full md:min-w-[720px]">
        <div className="w-full" style={{ aspectRatio: '16 / 9' }}>
          <iframe
            src={src}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            className="w-full h-full"
          ></iframe>
        </div>
      </DialogContent>
    </Dialog>
  )
}
